import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { SelectedResponse, SelectedList, DefaultSelectedResponse } from '../shared/selected-response.model';

@Injectable({
    providedIn: 'root'
})
export class SelectedLendersService {
  private adminUrl: string;
  private isStarted: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private source: string = '';
  private subscription;
  private _selectedLenders$ = new BehaviorSubject<SelectedResponse>({
    lead_id: 0,
    lenders: []
  });

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.adminUrl = appConfig.adminUrl;
  }

  get selectedLenders$(): Observable<SelectedResponse> {
    this.isStarted.subscribe((value) => {
      if (value) {
        setTimeout(() => {
          // console.log('Run Timer');
          // Stop subscription if we not receive answer in 5 sec.
          let lenders = this._selectedLenders$.getValue()
          if (lenders.lead_id == 0) {
            DefaultSelectedResponse.status = 'default_angular_no_response';
            let defResponse = DefaultSelectedResponse;
            if (this.source == 'TY-top10') {
              let index = Math.round(Math.random()) > 0.5 ? 1 : 0;
              defResponse.lenders.splice(index, 1)
            }

            this._selectedLenders$.next(defResponse);
            if (this.subscription != undefined) {
              this.subscription.unsubscribe();
            }
          }
        }, 5000);
      }
    });

    return this._selectedLenders$;
  }

  getList(leadId: any, limit: any = 0, source: string = '')
  {
    this.source = source;
    let isStarted = this.isStarted.getValue();
    if (!isStarted) {
      // console.log('Strated');
      this.isStarted.next(true);
      let url = `${this.adminUrl}/selected_manager/consent_list/${leadId}`;

      url = `${url}?source=${source}&limit=${limit}`;

      this.subscription = this.http.get<SelectedResponse>(url)
      .pipe(
        catchError((error) => {
          return throwError('Something went wrong');
        })
      )
      .subscribe(
        (response) => {
          if (response?.lead_id != 0 && response?.lenders.length == 0) {

            let defResponse = DefaultSelectedResponse;
            if (this.source == 'TY-top10') {
              let index = Math.round(Math.random()) > 0.5 ? 1 : 0;
              defResponse.lenders.splice(index, 1)
            }
            // if we have no any clients in response
            DefaultSelectedResponse.status = 'default_angular_empty_response';
            this._selectedLenders$.next(defResponse);
          } else {
            this._selectedLenders$.next(response);
          }
        },
        (error) => {
          if (source != 'TY-top10') {
            DefaultSelectedResponse.status = 'default_angular_no_response';
            this._selectedLenders$.next(DefaultSelectedResponse);
            this.subscription.unsubscribe();
          }
        }
      );


      return this.subscription;
    }
  }
}
